var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',{staticClass:"justify-content-center"},[_c('div',{staticClass:"col-md-5 col-12"},[_c('router-view')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }